import React, { useEffect } from 'react';
import styles from './StudentProfile.module.scss';
import PageHeader from '../../components/templates/pageHeader/PageHeader';
import Text from '../../components/atoms/text/Text';
import { useLocation, useNavigate } from 'react-router-dom';
import homeIcon from '../../assets/images/blachHomeIcon.svg';
import arrow from '../../assets/images/pathSingleTeam.svg';
import useScrollToTop from '../../app/hooks/useScrollToTop';
const imageNotFound = '/images/studentCard.png';
import DOMPurify from 'dompurify';
import useIsRtl from '../../app/helpers/isRtl';
import { useMediaQuery } from 'react-responsive';

const StudentProfile = () => {
  useScrollToTop();
  const isRtl = useIsRtl();
  const location = useLocation();
  const navigate = useNavigate();
  const studentData =
    location.state?.student ||
    JSON.parse(localStorage.getItem('student-profile-data') || '{}');
  const img = DOMPurify.sanitize(
    studentData?.facultyImage
      ? studentData?.url + studentData?.facultyImage
      : imageNotFound
  );
  const handleBackClick = () => {
    navigate('/about/team');
  };

  useEffect(() => {
    if (location.state?.student) {
      localStorage.setItem(
        'student-profile-data',
        JSON.stringify(location.state.student)
      );
    }
  }, [location.state?.student]);
  return (
    <div className={styles['student-information']}>
      <img
        src={img}
        className={`${styles.profileImage} ${!studentData?.facultyImage ? styles['full-w'] : ''}`}
        alt="Profile"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = imageNotFound;
        }}
        loading="lazy"
        decoding="async"
      />
      <PageHeader
        style={{ height: '100vh' }}
        backdropStyle={{ height: '100vh' }}
        data={{ title: 'Team.General_Information' }}
        component={
          <div className={styles['general-info']}>
            <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Name'} variant="text-bold-18" />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text
                title={
                  studentData
                    ? `${
                        isRtl
                          ? studentData?.fullName_AR
                          : studentData?.fullName_AR
                      }`
                    : ''
                }
                variant="text-bold-18"
              />
            </div>

            {/* <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Position'} variant="text-bold-18" />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text
                title={
                  studentData
                    ? `${
                        isRtl ? studentData.positionEN : studentData.positionAR
                      }`
                    : ''
                }
                variant="text-bold-18"
              />
            </div> */}

            <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text
                  title={'registrationPage.Phone_Label'}
                  variant="text-bold-18"
                />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text title={studentData?.phoneNumber} variant="text-bold-18" />
            </div>

            <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Academic_Degree'} variant="text-bold-18" />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text
                title={
                  studentData
                    ? `${
                        isRtl
                          ? `${studentData?.educationAR}`
                          : `${studentData?.educationAR}`
                      }`
                    : ''
                }
                variant="text-bold-18"
              />
            </div>

            <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Languages'} variant="text-bold-18" />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text
                title={
                  studentData
                    ? `${isRtl ? studentData?.languagesAR : studentData?.languagesAR}`
                    : ''
                }
                variant="text-bold-18"
              />
            </div>

            {/* <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Experience'} variant="text-bold-18" />
              </div>
              <Text
                title={
                  studentData
                    ? `: ${
                        isRtl
                          ? studentData.experienceEn || ''
                          : studentData.experienceAr || ''
                      }`
                    : ': '
                }
                variant="text-bold-18"
              />
            </div> */}

            <div className={styles['text-container']}>
              <div className={styles.text}>
                <Text title={'Team.Email'} variant="text-bold-18" />
                <Text title=": " variant="text-bold-18" />
              </div>
              <Text
                title={studentData ? `${studentData?.email}` : ''}
                variant="text-bold-18"
              />
            </div>
          </div>
        }
        extraComponent={
          <div
            className={`${styles['navigation-container']} ${isRtl ? styles['navigation-rtl'] : ''}`}
          >
            <div className={styles.buttonSvg}>
              <div
                onClick={handleBackClick}
                className={styles.profileImageButton}
              >
                <img
                  src={homeIcon}
                  alt="Profile"
                  className={styles.profilesvgs}
                  onClick={handleBackClick}
                />
              </div>
              <Text
                title="home.team"
                variant="text-bold-20-black"
                style={{ textTransform: 'uppercase', cursor: 'pointer' }}
                onClick={handleBackClick}
              />
            </div>
            <div className={styles.buttonSvg}>
              <img
                src={arrow}
                alt="arrow"
                className={`${isRtl ? styles['dir'] : ''}`}
              />
              <Text
                title={
                  studentData
                    ? `${isRtl ? studentData.fullName_AR : studentData.fullName_AR}`
                    : ''
                }
                variant="text-bold-20-black"
              />
            </div>
          </div>
        }
      />{' '}
    </div>
  );
};

export default StudentProfile;
